const expressBtn = document.getElementById("express-order-btn");   // Express Bulk Order
const sampleBtn  = document.getElementById("sample-order-btn");    // Buy 1 Sample
const expressPopup   = document.getElementById("express-popup");
const expressClose   = document.querySelector(".express-popup-close");
const expressBackdrop = document.querySelector(".express-popup-backdrop");
const printButtons = document.querySelectorAll(".print-btn");
const visualBtn = document.getElementById("visual-quote-btn");
const hiddenPMInput = document.getElementById("print-method");
const logoGroup = document.getElementById("logoUploadGroup");
const sampleTypeGroup = document.getElementById("sample-type-group");
const hiddenMode    = document.getElementById("hiddenMode")
const hiddenPM      = document.getElementById("hiddenPrintMethod");
const sampleContainer = document.getElementById("productMeta");
const sampleAvailable = sampleContainer?.dataset.sample || "";
const colorEl       = document.getElementById("eqProductColor");
const hiddenColor   = document.getElementById("hiddenColor");
const priceMsg      = document.getElementById("priceMsg");



window.selectedPrintMethod = "customized";
hiddenPM.value = window.selectedPrintMethod || "";


// Track which button user clicked (sample/express)
let lastClickedButton = null;

/* ==========================================================
   COLOR VARIATION
========================================================== */
const colorRadios = document.querySelectorAll('input[type="radio"][name*="Color"], input[type="radio"][name*="color"]');

  function updateColor() {
      const checked = document.querySelector('input[type="radio"][name*="Color"]:checked, input[type="radio"][name*="color"]:checked');
        if (!checked) return;
      const selectedColor = checked.value;
        // Update popup preview
      if (colorEl) {
            colorEl.textContent = "Color: " + selectedColor;
      }
      // Update hidden field
      if (hiddenColor) {
          hiddenColor.value = selectedColor;
      }
  }

  // Listen for color change
  colorRadios.forEach(radio => {
      radio.addEventListener("change", updateColor);
  });
  // When popup opens → update color also
  window.updatePopupColor = updateColor;


/* ==========================================================
   OPEN POPUP
========================================================== */
const openPopup = (forceOne = false, clickedFrom = "") => {

  // store last clicked type for logic
  lastClickedButton = clickedFrom;   // "sample" or "express"
  hiddenMode.value = clickedFrom || "";
  const eqQtyInput = document.getElementById("eqQuantity");

  let finalQty;

  if (forceOne) {
    finalQty = 1;   // BUY 1 SAMPLE → quantity always 1
  } else {
    finalQty = window.selectedQty || document.getElementById("cqty-input")?.value;
  }

  if (eqQtyInput && finalQty) {
    eqQtyInput.value = finalQty;
  }

  // === OPEN POPUP ===
  expressPopup.classList.remove("hidden");

  // Decide whether to show sample radio group
  updateSampleTypeVisibility();

};


/* ==========================================================
   CLOSE POPUP
========================================================== */
const closePopup = () => {
  expressPopup.classList.add("hidden");
};



/* ==========================================================
   EXPRESS BULK ORDER BUTTON
========================================================== */
if (expressBtn) {
  expressBtn.addEventListener("click", function (e) {
    if (!window.selectedPrintMethod) {
      e.preventDefault();
      e.stopPropagation();
      // alert("Please select a print method first");
      return; // stop here
    }

    //Color variation function call
    updatePopupColor();

    //Message
    priceMsg.style.display = "block";
    
    // === Normal popup ===
    openPopup(false, "express");
  });
}

/* ==========================================================
   SAMPLE BUTTON
========================================================== */
if (sampleBtn) {
  sampleBtn.addEventListener("click", function (e) {
    // === CASE 2: Normal validation (print method required) ===
    if (!window.selectedPrintMethod) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    if (sampleAvailable === "false" && window.selectedPrintMethod === "non-customized") {
      openPopup(true, "sample");
      return;  // stop further checks
    }

    // === CASE 3: If NON-CUSTOMIZED + sample available → popup block? (your older logic) ===
    if (window.selectedPrintMethod === "non-customized") {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    //Color variation function call
    updatePopupColor();

    //Message
    priceMsg.style.display = "none";

    // === CASE 4: Normal popup ===
    openPopup(true, "sample");
  });
}

/* ==========================================================
   VISUAL QUOTE (DIGITAL MOCKUP)
========================================================== */
if (visualBtn) {
  visualBtn.addEventListener("click", function () {

    const pm = window.selectedPrintMethod;

    if (!pm || pm === "" || pm === "non-customized") {
      alert("Please select the print method - customize.");
      return;
    }

    openPopup(false, "express");   // visual opens same popup as express bulk
  });
}


// CLOSE BTN
if (expressClose) {
  expressClose.addEventListener("click", closePopup);
}

// BACKDROP CLOSE
if (expressBackdrop) {
  expressBackdrop.addEventListener("click", closePopup);
}


// === function to show/hide SAMPLE TYPE RADIOS ===
function updateSampleTypeVisibility() {
  if (!sampleTypeGroup) return;

  if (window.selectedPrintMethod === "customized" && lastClickedButton === "sample" && sampleAvailable==="false" ) {
    sampleTypeGroup.style.display = "none";
  } else if(window.selectedPrintMethod === "customized" && lastClickedButton === "sample") {
    sampleTypeGroup.style.display = "block";
  } else{
    sampleTypeGroup.style.display = "none";
  }
}

/* ==========================================================
   PRINT METHOD BUTTONS
========================================================== */
printButtons.forEach(btn => {
  btn.addEventListener("click", () => {
    const value = btn.dataset.value;   // customized / non-customized
    window.selectedPrintMethod = value;
    hiddenPM.value = value || "";

    // ==== LOGO FIELD SHOW/HIDE ====
    if (logoGroup) {
      if (value === "customized") {
        logoGroup.style.display = "block";
      } else {
        logoGroup.style.display = "none";
      }
    }

    // Update radio group visibility based on conditions
    updateSampleTypeVisibility();
  });
});

// =================================================
// THANK YOU POPUP HANDLER
// =================================================
// const thankPopup = document.getElementById("thank-you-popup");
// const thankOkBtn = document.getElementById("thank-ok-btn");

// function showThankYouPopup() {
//   if (expressPopup) expressPopup.classList.add("ty-hidden");
//   if (thankPopup) thankPopup.classList.remove("ty-hidden");
// }

// // Close popup
// if (thankOkBtn) {
//   thankOkBtn.addEventListener("click", function () {
//     thankPopup.classList.add("ty-hidden");
//   });
// }
